export default {
  main: '#fff',
  secondary: '#EBC15B',
  contrastingColor: '#000',
  priceColor: '#EBC15B',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
